/** Типы событий календаря: те же id, что в API `event_type`. */
export interface CalendarEventTypeDef {
  id: string;
  name: string;
  color: string;
  icon: string;
}

export const CALENDAR_EVENT_TYPES: CalendarEventTypeDef[] = [
  { id: 'work-meeting', name: 'Рабочая встреча', color: '#4A6FA5', icon: '📅' },
  { id: 'meeting', name: 'Совещание', color: '#62A8D1', icon: '⚡' },
  { id: 'business-trip', name: 'Командировка', color: '#7A6FD1', icon: '✈️' },
  { id: 'custom', name: 'Пользовательское событие', color: 'rgb(28 195 172 / 70%)', icon: '📌' },
  { id: 'employee-birthday', name: 'Дни рождения сотрудников', color: '#D67BA8', icon: '🤓' },
  { id: 'client-birthday', name: 'Дни рождения клиентов', color: '#E6B75C', icon: '🎉' },
  { id: 'court-session', name: 'Судебное заседание', color: '#5B776B', icon: '⚖️' },
  { id: 'corporate', name: 'Корпоративные события', color: '#6FD1C1', icon: '🎊' },
];

/** Для селектов модалок без поля `icon`. */
export const CALENDAR_EVENT_TYPE_OPTIONS = CALENDAR_EVENT_TYPES.map(({ id, name, color }) => ({
  id,
  name,
  color,
}));

export function getCalendarEventTypeDef(typeId: string | undefined | null): CalendarEventTypeDef {
  const id = typeId || 'custom';
  return CALENDAR_EVENT_TYPES.find((t) => t.id === id) ?? CALENDAR_EVENT_TYPES.find((t) => t.id === 'custom')!;
}
